import { render } from "./ClinicalSafetyDashboard.vue?vue&type=template&id=f3c9885c&scoped=true"
import script from "./ClinicalSafetyDashboard.js?vue&type=script&lang=js"
export * from "./ClinicalSafetyDashboard.js?vue&type=script&lang=js"

import "./ClinicalSafetyDashboard.vue?vue&type=style&index=0&id=f3c9885c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c9885c"]])

export default __exports__